import * as MonthCode from "./month-code.js";
const shortMonthToNum = {
    JAN: "01",
    FEB: "02",
    MAR: "03",
    APR: "04",
    MAY: "05",
    JUN: "06",
    JUL: "07",
    AUG: "08",
    SEP: "09",
    OCT: "10",
    NOV: "11",
    DEC: "12",
};
export const shortMonths = Object.keys(shortMonthToNum);
export const monthNumberStringFromISODateString = (date) => date.substring(5, 7);
export const monthNumberStringFromShortMonth = (val) => shortMonthToNum[val];
export const monthNumberStringFromShortMonthYY = (val) => shortMonthToNum[fromShortMonthYY(val)];
export const monthNumberStringFromMonthIndex = (monthIndex) => (monthIndex + 1).toString().padStart(2, "0");
export const monthNumberStringFromMonthCode = (monthCode) => monthNumberStringFromMonthIndex(MonthCode.monthIndexFromMonthCode(monthCode));
export const monthNumberStringFromMonthCodeYY = (monthCode) => monthNumberStringFromMonthCode(MonthCode.monthCodeFromMonthCodeYY(monthCode));
export const monthNumberFromISODateString = (date) => Number(monthNumberStringFromISODateString(date));
const months = Object.keys(shortMonthToNum);
export const is = (month) => month in shortMonthToNum;
export const fromISODateString = (val) => months[monthNumberFromISODateString(val) - 1];
export const fromMonthIndex = (index) => months[index];
export const fromMonthCodeYY = (monthCode) => MonthCode.monthCodeToShortMonth[MonthCode.monthCodeFromMonthCodeYY(monthCode)];
export const fromShortMonthYY = (val) => val.slice(0, 3);
export const fromCiShortMonthYY = (val) => val.slice(0, 3).toUpperCase();
export const fromDate = (date) => shortMonths[date.getMonth()];
export const fromUTCDate = (date) => shortMonths[date.getUTCMonth()];
export const fromDayjs = (date) => date.format("MMM").toUpperCase();
//# sourceMappingURL=short-month.js.map